<template>
  <div class="container">
    <el-form
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-position="labelPosition"
      label-width="80px"
      :inline="true"
    >
      <el-form-item label="进货价格" prop="purchasePrice">
        <el-input v-model="formData.purchasePrice" placeholder="进货价格" />
      </el-form-item>
      <el-form-item label="零售价格" prop="retailPrice">
        <el-input v-model="formData.retailPrice" placeholder="零售价格" />
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <template v-if="isEdit">
        <el-button type="primary" @click="submitData('ruleForm')"
          >提交</el-button
        >
        <el-button @click="resetField('ruleForm')">取消</el-button>
      </template>
    </div>
  </div>
</template>
<script>
import { drugsSetMarketable, setSoldOut } from "@/api/doctor.js";
export default {
  name: "DrugListUpDrug",
  props: {
    isEdit: { type: Number, default: 0 },
    itemList: {
      type: Object,
      default: () => [],
    },
  },
  data() {
    return {
      labelPosition: "left",
      formData: {},
      rules: {
        purchasePrice: [
          { required: true, message: "请填写进货价格", trigger: "blur" },
        ],
        retailPrice: [
          { required: true, message: "请填写零售价格", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    async submitData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.audit();
        } else {
          return false;
        }
      });
    },
    async audit() {
      const params = {
        storeId: 1, // 药店id
        drugId: this.itemList.id,
        purchasePrice: this.formData.purchasePrice,
        retailPrice: this.formData.retailPrice,
      };

      const res = await drugsSetMarketable(params); // 上架
      let mess = "上架成功";

      if (res.code === 1) {
        this.$message({
          message: mess,
          type: "success",
        });
        this.$emit("refresh");
      }
    },
    resetField(formName) {
      this.$refs[formName].resetFields();
      this.$emit("closeForm");
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  float: left !important;
  margin-right: 30px !important;
  margin-right: 10px !important;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 185px !important;
}
.el-dialog {
  margin-top: 8vh;
  width: 80%;
}
.category {
  float: left;
  width: 100%;
  height: 30px;
  border-bottom: 1px solid #dcdfe6;
  margin: 0 15px 20px 0;
  font-weight: 600;
  font-size: 16px;
}
.dialog-footer {
  clear: both;
}
</style>
